import QuestionEdit from './QuestionEdit';

export default QuestionEdit;
